"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const ComboBoxDropdownSearchContext = createContext({
  hideSearch: false,
  dropdownSearchInputValue: "",
  setDropdownSearchInputValue: () => null,
  searchSource: "indeterminate",
  setSearchSource: () => {
  }
});
ComboBoxDropdownSearchContext.displayName = "ComboBoxDropdownSearchContext";
function useComboBoxDropdownSearchContext() {
  return useContext(ComboBoxDropdownSearchContext);
}

export { ComboBoxDropdownSearchContext, useComboBoxDropdownSearchContext };
